import { Component } from 'react';
import { Control } from 'forms/rrf';
import { FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BsCheckbox from './bs-checkbox';

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    const {
      model, controlId, errorLabel, options
    } = this.props;

    return (
      <FormGroup controlId={controlId} className={`form-group${this.state[errorLabel] ? ` has-${this.state[errorLabel]}` : ''}`}>
        {options.map((option, index) => (
          <div key={index}>
            <Control.checkbox
              component={BsCheckbox}
              disabled={option.disabled}
              model={`${model}.${option.value}.value`}
              value={option.value}
            >
              {option.label}
            </Control.checkbox>
          </div>
        ))}
      </FormGroup>
    );
  }
}

CheckboxGroup.propTypes = {
  model: PropTypes.string.isRequired,
  controlId: PropTypes.string,
  options: PropTypes.array,
};

CheckboxGroup.defaultProps = {
  controlId: Math.random()
    .toString(16)
    .substring(2)
};

export default CheckboxGroup;
